import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

import * as serviceWorker from '../../../src/serviceWorker';
import auth from '../../services/Auth';

const ServiceWorkerWrapper = () => {
  const [serviceWorkerInitialized, setServiceWorkerInitialized] = useState(false);

  useEffect(() => {
    console.log('[Service worker] Init service worker wrapper');
    serviceWorker.register({
      onUpdate: registration => {
        console.log('[Service worker] registration : ', registration);
        const waitingServiceWorker = registration.waiting;
        if (waitingServiceWorker) {
          console.log('[Service worker] Service worker waiting :', registration.waiting);
          waitingServiceWorker.addEventListener('statechange', event => {
            console.log('[Service worker] state change :', event.target.state);
            if (event.target.state === 'activated') {
              console.log('[Service worker] Service worker updated!');
              setServiceWorkerInitialized(true);
            }
          });
          waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
        }
      },
    });
  }, [serviceWorkerInitialized]);

  const forceReload = () => {
    // delete some local storage
    localStorage.removeItem('valuereport-summary');

    console.log('Force reload!');
    auth.logout({
      redirectToLogin: false,
    });
    auth.forceReload();
  };

  return (
    <Dialog
      open={serviceWorkerInitialized}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setServiceWorkerInitialized(false);
        }
      }}
    >
      <DialogTitle id='alert-dialog-title' className={'text-alert'}>
        Une nouvelle version de l'application est disponible!
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={'text-dark'}>
          Afin d'avoir la meilleure expérience possible, Veuillez redémarrer l'application en cliquant sur le bouton
          suivant.
          <br />
          <Button
            color='primary'
            onClick={forceReload}
            type='button'
            variant='contained'
            className={'w-100 mt-5'}
            disableElevation
          >
            Recharger
          </Button>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceWorkerWrapper;
